export const IMAGE_UPLOAD_SUCCESSFUL='IMAGE_UPLOAD_SUCCESSFUL'
export const IMAGE_UPLOAD_FAILURE='IMAGE_UPLOAD_FAILURE'



// WEBPACK FOOTER //
// ./src/image-uploader/action-types.js